<script lang="ts">
	export let credits: number;
</script>

<div class="flex flex-col lg:flex-row justify-center">
	<div
		class="w-fit h-fit p-3 flex flex-col justify-start items-start border rounded shadow-sm
		border-primary-200 bg-primary-50 dark:border-zinc-800 dark:bg-zinc-900"
	>
		<div class="text-zinc-900 dark:text-zinc-200 text-xs flex flex-row items-center">
			<i class="fa-solid fa-images mr-2 text-cyan-600 dark:text-cyan-400 dark:opacity-80"></i>
			Project Pack generations remaining: <span class="font-semibold ml-1">{credits}</span>
		</div>
	</div>
</div>